import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'
import NotFound from '../Pages/NotFound'
import Default from './Attraction/Default'
import Popular from './Attraction/Popular'
import AttractionMapping from './Attraction/AttractionMapping'
import NewAttractionMapping from './Attraction/NewAttractionMapping'
import Reviews from './Attraction/Reviews'
import CronReport from './Attraction/CronReport'

const subList = {
  Default: <Default />,
  Popular: <Popular />,
  AttractionMapping: <AttractionMapping />,
  NewAttractionMapping: <NewAttractionMapping />,
  Reviews: <Reviews />,
  CronReport: <CronReport />
}

const SubComponent = ({ subname = 'default' }) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const AttractionPage = ({ location, match }) => <SubComponent subname={match.params.sub} location={location} />

export default AttractionPage



// WEBPACK FOOTER //
// ./src/Pages/AttractionPage.js